import m from 'mithril'
import classNames from 'classnames'
import {
    Search,
    Conditions
} from '../models'
import {
    TextBox
} from '../components'

class CliamForm {
    constructor() {
        var i = 0
        this.show = false
        this.search = {
            conditions: []
        }

        this.chosen_conditions = []

        this.search_item = {
            conditions: []
        }

        this.house = []

        this.house_id = 51

        this.conditions = new Conditions
        this.conditions.houseId = 51


        Search.fetch().then((responsive) => {
            this.search.conditions = responsive.conditions
        })

        Conditions.get().then((responsive) => {
            this.house = responsive
        })

        Conditions.load(this.house_id).then((responsive) => {
            // this.conditions.internet = responsive.internet
            // this.conditions.aircondition = responsive.aircondition
            // this.conditions.gas = responsive.gas
            // this.conditions.sofa = responsive.sofa
            // this.conditions.balcony = responsive.balcony //陽台
            // this.conditions.furniture = responsive.furniture //家具
            // this.conditions.tv = responsive.tv
            // this.conditions.waterHeater = responsive.waterHeater
            // this.conditions.bed = responsive.bed //床
            // this.conditions.cable = responsive.cable //有線電視
            // this.conditions.cook = responsive.cook
            // this.conditions.furniturePlus = responsive.furniturePlus //傢俱選配加值服務
            // this.conditions.refrigerator = responsive.refrigerator //冰箱
            // this.conditions.washMachine = responsive.washMachine //洗衣機
            // this.conditions.wardrobe = responsive.wardrobe //衣櫃
            // this.conditions.accessControl = responsive.accessControl //門禁管理
            // this.conditions.barrier = responsive.barrier //無障礙空間
            this.conditions.claimValues = responsive
        })

    }

    save(event, value) {
        this.conditions.save().then(() => {
            alert('checked')
            Conditions.get().then((responsive) => {
                this.house = responsive
            })
        })
    }


    view() {

        return [m(".pt-195"),
        [m("ul.other-features",
            [
                m("select.form-control.mb-3", {
                    style: {
                        backgroundColor: '#eee',
                        minWidth: '90px'
                    },
                    onchange: (e) => {
                        this.house_id = e.target.value
                        this.conditions.houseId = e.target.value
                        Conditions.load(this.house_id).then((responsive) => {
                            this.conditions.claimValues = responsive
                        })
                        Search.fetch().then((responsive) => {
                            this.search.conditions = responsive.conditions
                        })
                    }
                }, [
                    this.house.map((item, index) => {
                        return m('option', {
                            selected: this.house_id == item.id,
                            value: item.id
                        }, item.id + item.houseName + '----' + item.dateCreated)
                    })
                ]),
                this.search.conditions.map((condition) => {
                    return [m("li", {
                        style: {
                            "width": "50%"
                        }
                    },
                        [
                            m(`input[id='el-${condition.id}'][type='checkbox']`, {
                                style: {
                                    height: '25px',
                                    width: '25px',
                                },
                                checked: this.conditions.checkAuth(condition.name),
                                onclick: (e) => {
                                    this.conditions.toggleAuth(condition.name)
                                }
                            }),
                            m(`label.w-75[for='el-${condition.id}']`, {
                                style: {
                                    fontSize: '1.8rem',
                                }
                            },
                                condition.name
                            )
                        ]
                    )]
                })
            ]
        ),
        m(".text-right.text-lg-center.pb-15", {
            style: {
                "margin-top": "-15px"
            }
        },
            m("Button", {
                class: 'btn-primary',
                onclick: this.save.bind(this)
            }, '儲存'),
        )
        ]
        ]

    }
}

export default CliamForm